export default ($axios) => ({
  fetchAgents(query) {
    return $axios.get('/omni/agents', { params: query }).then((response) => response.data);
  },
});
